var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(_vm.isNumber)?_c('span',{key:"is-number"},[_vm._v(_vm._s(_vm._f("formatCurrency")(_vm.value,_vm.currency, { actualNumber: _vm.actualNumber })))]):_c('span',{key:"is-not-number"},[_vm._v(_vm._s(_vm.errorText))])])
}
var staticRenderFns = []

export { render, staticRenderFns }